import { styled, TableCell } from '@mui/material';

const HeadTableCell = styled(TableCell)`
  font-size: 1.6rem;
  font-family: var(--enFont);
  font-weight: bold;
  color: var(--mainOrange);
  background: var(--blackHover);
`;

export default HeadTableCell;
